import { Component, Input, Output, EventEmitter, inject } from "@angular/core";
import { TranslocoPipe, provideTranslocoScope } from "@jsverse/transloco";
import { WorkspaceButtonConfig } from "@models/workspace/WorkspaceButtonConfig";
import { CerrixPromptService } from "@app/shared/services/cerrix-prompt.service";

@Component({
    selector: "detail-options",
    templateUrl: "./detail-options.component.html",
    styleUrls: ["./detail-options.component.scss"],
    imports: [TranslocoPipe],
    providers: [
        provideTranslocoScope({ scope: "shared/components/detail-options", alias: "detailOptions" })
    ]
})
export class DetailOptionsComponent {
    private _promptService = inject(CerrixPromptService);

    @Input() moduleName: string;
    @Input() objectName: string;
    @Input() customText: string = "";

    @Input() buttonConfig: WorkspaceButtonConfig[] = [];

    @Input() allowDelete = true;
    @Output() onDelete = new EventEmitter();

    // The prompt text is resolved by the template's transloco pipe and passed in, so the scope is
    // always loaded by the time the button can be clicked. This avoids an imperative translate().
    deleteClick(promptTitle: string, defaultText: string) {
        if (!this.allowDelete) {
            return;
        }

        const popupText = this.customText ? this.customText : defaultText;

        this._promptService
            .confirm(promptTitle, popupText)
            .onConfirm()
            .subscribe(() => {
                this.onDelete.emit();
            });
    }

    buttonClick(config: WorkspaceButtonConfig) {
        if (config.isDisabled !== true && config.clickEvent) {
            config.clickEvent();
        }
    }
}
